import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-40104ea0")

_pushScopeId("data-v-40104ea0")
const _hoisted_1 = {
  "data-testid": "booking-v4-sender-section",
  class: "w-full"
}
const _hoisted_2 = { class: "flex flex-col gap-y-3" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_4 = { class: "flex flex-col gap-y-3" }
const _hoisted_5 = { class: "flex items-center gap-x-2 w-full" }
const _hoisted_6 = { class: "text-14px font-medium text-gray-lp-300 col-span-3 text-left" }
const _hoisted_7 = { class: "flex flex-col gap-1 w-full mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px pl-1 py-1 flex gap-x-2 bg-red-lp-1100 rounded-lg my-2"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex space-x-1 items-center" }
const _hoisted_12 = { class: "w-full flex flex-col text-12px font-montserrat" }
const _hoisted_13 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_FieldKlienV4 = _resolveComponent("FieldKlienV4")!
  const _component_SelectCustomer = _resolveComponent("SelectCustomer")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_LpInput = _resolveComponent("LpInput")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Title, {
          label: _ctx.$t('bookingV4.detailSender'),
          fontSize: 16,
          bold: "bold",
          fontColor: "text-black-lp-100"
        }, null, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.isInternational)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.$t('bookingV4.sender.country.label'),
              class: "col-span-2 w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  id: "booking-v4-sender-country-dropdown",
                  "data-testid": "booking-v4-sender-country-dropdown",
                  class: "mt-2",
                  serverSide: false,
                  keyName: "label",
                  keyValue: "code",
                  options: _ctx.countryListFiltered,
                  placeholder: _ctx.$t('bookingV4.sender.country.placeholder'),
                  "model-value": _ctx.selectedCountry,
                  errorMessage: _ctx.$t('bookingV4.sender.country.error.notFound'),
                  isShowErrorIndicator: !!_ctx.errorMessageCountry,
                  errorCaption: _ctx.errorMessageCountry,
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.senderCountryIndex))),
                  onBlur: _ctx.onValidateCountry,
                  "onUpdate:modelValue": _ctx.onChangeOriginCountry,
                  isDisabled: 
              (!!_ctx.modelValue.sender.originCountryCode && !_ctx.isInternalAccount) ||
                _ctx.isEdit
            ,
                  disabledBackground: 
              (!!_ctx.modelValue.sender.originCountryCode && !_ctx.isInternalAccount) ||
                _ctx.isEdit
            
                }, {
                  "selected-prefix": _withId(({ selected }) => [
                    (selected?.flag)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "self-center w-4 mr-2",
                          alt: selected.name,
                          src: selected.flag
                        }, null, 8, ["alt", "src"]))
                      : _createCommentVNode("", true)
                  ]),
                  "custom-option": _withId(({ item }) => [
                    _createVNode("button", _hoisted_5, [
                      (item?.flag)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "self-center w-4",
                            alt: item.name,
                            src: item.flag
                          }, null, 8, ["alt", "src"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_6, _toDisplayString(item.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "placeholder", "model-value", "errorMessage", "isShowErrorIndicator", "errorCaption", "onBlur", "onUpdate:modelValue", "isDisabled", "disabledBackground"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.showClientField)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: _ctx.$t('bookingV4.client.label'),
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_FieldKlienV4, {
                  class: "mt-2",
                  selectedClient: _ctx.selectedClient,
                  errorMessage: _ctx.clientErrorMessage,
                  clients: _ctx.clients,
                  origins: _ctx.clientOrigins,
                  selectedOrigin: _ctx.selectedClientOrigin,
                  selectedServiceTypes: _ctx.selectedClientServiceTypes,
                  searchKeyword: _ctx.clientSearchKeyword,
                  isInitialLoading: _ctx.isClientInitialLoading,
                  isLoadingMore: _ctx.isClientLoadingMore,
                  hasNextPage: _ctx.clientHasNextPage,
                  listErrorMessage: _ctx.clientListErrorMessage,
                  isOriginLoading: _ctx.isClientOriginLoading,
                  originsHasNextPage: _ctx.clientOriginsHasNextPage,
                  isDisabled: _ctx.isClientDisabled,
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('client-focus'))),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('client-blur'))),
                  onTab: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('client-tab'))),
                  onCloseList: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('client-close-list'))),
                  onOpenList: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('client-open-list'))),
                  "onUpdate:search": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:client-search', $event))),
                  "onUpdate:origin": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:client-origin', $event))),
                  "onUpdate:serviceTypes": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:client-service-types', $event))),
                  onOriginFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('client-origin-focus'))),
                  onOriginFilter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('client-origin-filter', $event))),
                  onOriginScrolled: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('client-origin-scrolled', $event))),
                  onLoadMore: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('client-load-more'))),
                  onSelect: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('client-select', $event))),
                  onClear: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('client-clear'))),
                  onRetry: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('client-retry')))
                }, null, 8, ["selectedClient", "errorMessage", "clients", "origins", "selectedOrigin", "selectedServiceTypes", "searchKeyword", "isInitialLoading", "isLoadingMore", "hasNextPage", "listErrorMessage", "isOriginLoading", "originsHasNextPage", "isDisabled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configName.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              label: _ctx.$t('bookingV4.name'),
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectCustomer, {
                  id: "booking-v4-sender-name-input",
                  "data-testid": "booking-adjust-v4-sender-name-input",
                  column: "Pengirim",
                  placeholder: "bookingV4.sender.name.placeholder",
                  customerName: _ctx.modelValue.sender.name,
                  "onUpdate:customerName": [
                    _cache[17] || (_cache[17] = ($event: any) => (_ctx.modelValue.sender.name = $event)),
                    _ctx.onChangeName
                  ],
                  loading: _ctx.loadingCustomerList,
                  options: _ctx.customerList,
                  keyName: "customerPhoneNumber",
                  error: !!_ctx.errorMessageName,
                  errorCaption: _ctx.errorMessageName,
                  onFocus: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onFocusCustomer(_ctx.senderNameIndex, _ctx.modelValue.sender.name))),
                  onBlur: _ctx.onValidateName,
                  onSelect: _ctx.onSelectCustomer,
                  isBookingV3: true,
                  useInfiniteScroll: "",
                  onScrolled: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onScroll(_ctx.modelValue.sender.name))),
                  class: "mt-2",
                  disabled: _ctx.disabledName
                }, null, 8, ["customerName", "onUpdate:customerName", "loading", "options", "error", "errorCaption", "onBlur", "onSelect", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configPhone.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 3,
              label: _ctx.$t('bookingV4.phoneNumber')
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_SelectPhoneCountry, {
                    id: "booking-v4-sender-phone-input",
                    "data-testid": "booking-v4-sender-phone-input",
                    column: "Pengirim",
                    keyName: "customerName",
                    code: _ctx.modelValue.sender.phoneCode,
                    "onUpdate:code": [
                      _cache[20] || (_cache[20] = ($event: any) => (_ctx.modelValue.sender.phoneCode = $event)),
                      _ctx.onChangePhone
                    ],
                    phone: _ctx.modelValue.sender.phone,
                    "onUpdate:phone": [
                      _cache[21] || (_cache[21] = ($event: any) => (_ctx.modelValue.sender.phone = $event)),
                      _ctx.onChangePhone
                    ],
                    options: _ctx.customerList,
                    onSelect: _ctx.onSelectCustomer,
                    error: _ctx.errorMessagePhone,
                    isLoading: _ctx.loadingCustomerList,
                    onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onFocusCustomer(_ctx.senderPhoneIndex, _ctx.fullPhoneNumber))),
                    onBlur: _ctx.onValidatePhone,
                    disabled: _ctx.disabledPhone,
                    useInfiniteScroll: "",
                    onScrolled: _cache[23] || (_cache[23] = () => _ctx.onScroll(_ctx.fullPhoneNumber)),
                    bookingVersion: "v4"
                  }, null, 8, ["code", "onUpdate:code", "phone", "onUpdate:phone", "options", "onSelect", "error", "isLoading", "onBlur", "disabled"]),
                  (_ctx.isErrorFraudLimited || _ctx.isErrorFraudSuspected)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _hoisted_9,
                        (_ctx.isErrorFraudLimited)
                          ? (_openBlock(), _createBlock("div", _hoisted_10, [
                              _createVNode("div", _hoisted_11, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.limited1")), 1),
                                _createVNode("b", {
                                  class: "underline cursor-pointer",
                                  onMouseenter: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleTooltipLimited($event))),
                                  onMouseleave: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toggleTooltipLimited($event)))
                                }, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.limited2")), 33),
                                _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.limited3")), 1)
                              ]),
                              _createVNode(_component_OverlayPanel, {
                                ref: "limited",
                                appendTo: "body",
                                class: "w-1/4",
                                style: {
                    backgroundColor: '#ffffff',
                    color: '#4D4D4D'
                  }
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.limitedTooltip")), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isErrorFraudSuspected)
                          ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.suspected")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configAddress.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 4,
              label: _ctx.$t('bookingV4.address'),
              class: "col-span-2 w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  id: "booking-v4-sender-address-input",
                  "data-testid": "booking-v4-sender-address-input",
                  type: "textarea",
                  preventEnterTextArea: "",
                  showMaxLength: "",
                  textAreaRows: "3",
                  modelValue: _ctx.modelValue.sender.address,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.modelValue.sender.address = $event)),
                  error: !!_ctx.errorMessageAddress,
                  "error-caption": _ctx.errorMessageAddress,
                  format: _ctx.replaceNewLine,
                  placeholder: "bookingV4.sender.address.placeholder",
                  maxLength: _ctx.maxAddressLength,
                  disabled: _ctx.disabledAddress,
                  disableBackground: _ctx.disabledAddress,
                  onFocus: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.senderAddressIndex))),
                  onBlur: _ctx.onValidateAddress,
                  onChange: _ctx.onValidateAddress,
                  pbTextAreaWithLength: "pb-10",
                  sizeInput: "12px xxl:text-14px"
                }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength", "disabled", "disableBackground", "onBlur", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configDistrict.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 5,
              label: _ctx.$t('bookingV4.districtCity'),
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  id: "booking-v4-sender-district-dropdown",
                  "data-testid": "booking-v4-sender-district-dropdown",
                  class: "mt-2",
                  keyName: "name",
                  keyValue: "id",
                  "model-value": _ctx.modelValue.sender.originCity,
                  isDisabled: "",
                  disabledBackground: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})